export const setUp = () => {
  const keys = Object.keys(localStorage)

  keys.forEach((key) => {
    const object = localStorage.getItem(key)

    try {
      const parsed = JSON.parse(object)

      if (parsed.formValues) {
        localStorage.removeItem(key)
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('parsed error')
    }
  })
}

setUp()
